// extracted by mini-css-extract-plugin
export default {"maxHeight80":"imageCell_maxHeight80__5+MI5","noDataWrapper":"imageCell_noDataWrapper__23Haw"};